import { AGENT_STATUS } from '../../../core/constants/domain';

const STATUS_ORDER = [
    AGENT_STATUS.BLOCKED,
    AGENT_STATUS.RUNNING,
    AGENT_STATUS.WAITING,
    AGENT_STATUS.OFFLINE,
    AGENT_STATUS.CONNECTED,
];

export function leaseProgress(task, now = Date.now()) {
    if (!task?.claimedAt || !task?.claimedUntil) return null;
    const start = Date.parse(task.claimedAt);
    const end = Date.parse(task.claimedUntil);
    if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
    return Math.max(0, (now - start) / (end - start));
}

export function sortByAttention(entries) {
    return [...entries].sort((a, b) => STATUS_ORDER.indexOf(a.status) - STATUS_ORDER.indexOf(b.status));
}

export function decisionHeadline(count) {
    if (count === 0) return 'Nada espera tu decisión';
    if (count === 1) return '1 decisión te espera';
    return `${count} decisiones te esperan`;
}
